import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { ClientType } from 'state/secondaryMarket/shared/form.models';
import type { Collection } from 'state/utils/types';

export type Defaults = Readonly<{
  client?: ISalesCounterpart;
  clientType?: ClientType;
  settlementDate?: string;
  tradeWay?: TradeWay;
  salesId?: string;
}>;

export type DefaultsMap = Collection<Defaults>;

export const initialDefaults = (): Defaults => ({});

export const initialDefaultsMap = (): DefaultsMap => ({});
